module.exports = __webpack_public_path__ + "allData_logo.png?ad1690839ae5404807ad340420d3f177";